import { render } from "./FileUploadIcon.vue?vue&type=template&id=5e9d2e97&scoped=true"
const script = {}

import "./FileUploadIcon.vue?vue&type=style&index=0&id=5e9d2e97&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e9d2e97"]])

export default __exports__